module.exports = __webpack_public_path__ + "img/qr-code-scan.f3759352.svg";